var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAceEXchange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 240,
    viewBox: "0 0 240 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_246_1440)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M183.959 36H116.042C107.02 36 102.51 36 98.885 38.2402C95.2603 40.4805 93.2431 44.5149 89.2087 52.5836L78.6816 79.1947C76.2494 85.3429 74.1214 92.5893 78.2155 97.7811C80.9621 101.264 85.2198 103.5 89.9998 103.5C98.2841 103.5 105 96.7843 105 88.5C105 96.7843 111.716 103.5 120 103.5C128.284 103.5 135 96.7843 135 88.5C135 96.7843 141.716 103.5 150 103.5C158.284 103.5 165 96.7843 165 88.5C165 96.7843 171.716 103.5 180 103.5C188.284 103.5 195 96.7843 195 88.5C195 96.7843 201.716 103.5 210 103.5C214.78 103.5 219.038 101.264 221.785 97.781C225.879 92.5894 223.751 85.3429 221.319 79.1947L210.792 52.5836C206.757 44.5148 204.74 40.4805 201.115 38.2402C197.491 36 192.98 36 183.959 36Z",
    fill: "#777777",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M210 180.375H225C228.107 180.375 230.625 182.893 230.625 186C230.625 189.107 228.107 191.625 225 191.625H75C71.8934 191.625 69.375 189.107 69.375 186C69.375 182.893 71.8934 180.375 75 180.375H90L90 114.75C95.5772 114.75 100.748 113.011 105 110.045C109.252 113.011 114.423 114.75 120 114.75C125.577 114.75 130.748 113.011 135 110.045C139.252 113.011 144.423 114.75 150 114.75C155.577 114.75 160.748 113.011 165 110.045C169.252 113.011 174.423 114.75 180 114.75C185.577 114.75 190.748 113.011 195 110.045C199.252 113.011 204.423 114.75 210 114.75L210 180.375ZM131.25 180.375H168.75V159.75C168.75 152.74 168.75 149.236 167.243 146.625C166.255 144.915 164.835 143.495 163.125 142.507C160.514 141 157.01 141 150 141C142.99 141 139.486 141 136.875 142.507C135.165 143.495 133.745 144.915 132.757 146.625C131.25 149.236 131.25 152.74 131.25 159.75V180.375Z",
    fill: "url(#paint0_linear_246_1440)",
    fillOpacity: 0.3
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_246_1440)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.6392 109.461H37.361C31.3469 109.461 28.3399 109.461 25.9234 110.955C23.5068 112.448 22.162 115.138 19.4725 120.517L12.4544 138.258C10.833 142.357 9.41426 147.188 12.1437 150.649C13.9748 152.971 16.8132 154.461 19.9999 154.461C25.5227 154.461 29.9999 149.984 29.9999 144.461C29.9999 149.984 34.477 154.461 39.9999 154.461C45.5227 154.461 49.9999 149.984 49.9999 144.461C49.9999 149.984 54.477 154.461 59.9999 154.461C65.5227 154.461 69.9999 149.984 69.9999 144.461C69.9999 149.984 74.477 154.461 79.9999 154.461C85.5227 154.461 89.9999 149.984 89.9999 144.461C89.9999 149.984 94.477 154.461 99.9999 154.461C103.187 154.461 106.025 152.971 107.856 150.649C110.586 147.188 109.167 142.357 107.546 138.258L100.528 120.517C97.8382 115.138 96.4934 112.448 94.0768 110.955C91.6603 109.461 88.6533 109.461 82.6392 109.461Z",
    fill: "#777777"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100 205.711H110C112.071 205.711 113.75 207.39 113.75 209.461C113.75 211.532 112.071 213.211 110 213.211H10C7.92893 213.211 6.25 211.532 6.25 209.461C6.25 207.39 7.92893 205.711 10 205.711H20L20 161.961C23.7181 161.961 27.1654 160.802 30 158.825C32.8346 160.802 36.2819 161.961 40 161.961C43.7181 161.961 47.1654 160.802 50 158.825C52.8346 160.802 56.2819 161.961 60 161.961C63.7181 161.961 67.1654 160.802 70 158.825C72.8346 160.802 76.2819 161.961 80 161.961C83.7181 161.961 87.1654 160.802 90 158.825C92.8346 160.802 96.2819 161.961 100 161.961L100 205.711ZM47.5 205.711H72.5V191.961C72.5 187.288 72.5 184.952 71.4952 183.211C70.8369 182.071 69.8901 181.124 68.75 180.466C67.0096 179.461 64.6731 179.461 60 179.461C55.3269 179.461 52.9904 179.461 51.25 180.466C50.1099 181.124 49.1631 182.071 48.5048 183.211C47.5 184.952 47.5 187.288 47.5 191.961V205.711Z",
    fill: "#777777"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_246_1440",
    x: 50.7692,
    y: 11.7692,
    width: 198.462,
    height: 198.462,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.61538,
    result: "effect1_foregroundBlur_246_1440"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_246_1440",
    x: 0,
    y: 99.4614,
    width: 122.308,
    height: 122.308,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.30769,
    dy: 2.30769
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.30769
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_246_1440"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_246_1440",
    x1: 136,
    y1: 141.5,
    x2: 113,
    y2: 167.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#777777"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAceEXchange);
export default __webpack_public_path__ + "static/media/ACE_eXchange.01172fcf19bb9a9e515d1c1286a913eb.svg";
export { ForwardRef as ReactComponent };